import { render, staticRenderFns } from "./GP4BC_parameters.vue?vue&type=template&id=2ae1a7ca&scoped=true&"
import script from "./GP4BC_parameters.vue?vue&type=script&lang=js&"
export * from "./GP4BC_parameters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae1a7ca",
  null
  
)

export default component.exports